/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {LOADER_STATUS,SET_TABLE_DATA,SET_TOTAL_RECORD} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  tabelData:[],
  total_record:0
};

/* eslint-disable default-case, no-param-reassign */
const gstr1UploadReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_TABLE_DATA:
        return {
          ...state,
          tabelData:action.tabelData
        }
      case SET_TOTAL_RECORD:
        return {
          ...state,
          total_record:action.total_record
        }
      default:
        return state; 
    }
  };

export default gstr1UploadReducer;
